module.exports = __webpack_public_path__ + "img/one-life.2006656b.png";